<script>
import { getSubscribersList, uploadSubscribers } from "@/api/subscribers";
import { getLocations } from "@/api/locations";
import basicTemplate from "@/data/basicSubscribersCsvTemplate.json";
export default {
  data() {
    return {
      selectedFile: null,
      msg: "",
      parseData: [],
      subscribersLists: [],
      locations: [],
      subscriber_list_id: null,
      location_id: null,
      spinning: false
    };
  },
  async mounted() {
    this.subscribersLists = await getSubscribersList();
    this.locations = await getLocations();
    this.$store.commit("setFormData", null);
    this.spinning = false;
  },
  computed: {
    subscribersOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.subscribersLists.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    },
    locationsOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.locations.map(list => {
          return {
            value: list.id,
            text: list.name
          };
        })
      ];
    }
  },
  methods: {
    onSubmit() {
      if (this.selectedFile) {
        var file = this.selectedFile;
        this.$papa.parse(file, {
          header: true,
          newline: "",
          skipEmptyLines: true,
          complete: async results => {
            const payload = JSON.parse(
              JSON.stringify({
                subscriber_list_id: this.subscriber_list_id,
                location_id: this.location_id,
                subscribers: results.data
              })
            );
            // console.log(payload);
            this.spinning = true;
            this.msg = "Uploading subscribers...";
            const response = await uploadSubscribers(payload);
            // console.log(response.success);
            if (response.success) {
              this.$bvToast.toast(`Uploaded`, {
                title: "Subscriber",
                autoHideDelay: 3000,
                appendToast: false,
                variant: "info"
              });
              this.spinning = false;
              this.msg = "";
              this.selectedFile = null;
              this.subscriber_list_id = null;
              setTimeout(() => {
                this.$refs["modal-upload-subscribers"].hide();
                this.$store.dispatch("getSubscribersPaginated");
              }, 1000);
            }
          }
        });
      } else {
        this.msg = "Please upload a csv file";
        this.spinning = false;
      }
    },
    addSubscriber() {
      if (this.selectedFile) {
        var file = this.selectedFile;
        this.$papa.parse(file, {
          header: true,
          newline: "",
          skipEmptyLines: true,
          complete: results => {
            const payload = JSON.parse(
              JSON.stringify({
                subscriber_list_id: this.subscriber_list_id,
                location_id: this.location_id,
                subscribers: results.data
              })
            );
            // console.log(payload);
            this.spinning = true;
            this.$store.commit("setFormData", payload);
            this.$store.dispatch("uploadCsvSubscribers");
            this.msg = "Uploading subscribers...";
            setTimeout(() => {
              this.spinning = false;
              this.msg = "";
              this.selectedFile = null;
              this.subscriber_list_id = null;
              this.$refs["modal-upload-subscribers"].hide();
            }, 2000);
          }
        });
      } else {
        this.msg = "Please upload a csv file";
        this.spinning = false;
      }
    },
    download() {
      let csv = this.$papa.unparse(basicTemplate);
      this.$papa.download(csv, "BasicCsvTemplate");
    }
  }
};
</script>

<template>
  <b-modal
    id="modal-upload-subscribers"
    ref="modal-upload-subscribers"
    title="Upload Subscriber"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      id="mainForm"
    >
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-location"
            label="Location:"
            label-for="location-select"
          >
            <b-form-select
              id="location-select"
              v-model="location_id"
              :options="locationsOptions"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-subscriber-list"
            label="Subscribers List:"
            label-for="select-1"
          >
            <b-form-select
              id="subscriber-list"
              v-model="subscriber_list_id"
              :options="subscribersOptions"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <v-file-input
            v-model="selectedFile"
            truncate-length="15"
            accept=".csv"
            label="Click here to select a .csv file"
            required
          ></v-file-input>
          <div>{{ msg }}</div>
          <div>
            <a href="#" @click.prevent="download">
              Download sample csv template
            </a>
          </div>
        </b-col>
      </b-row>
      <b-button
        type="submit"
        class="float-right"
        variant="primary"
        v-if="!spinning"
      >
        Add Subscribers
      </b-button>
      <b-spinner
        v-show="spinning"
        label="Spinning"
        class="float-right"
      ></b-spinner>
    </b-form>
  </b-modal>
</template>
